<template>
<div>
    <div class="modal fade" id="add_table" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document" style="overflow-y: initial !important">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="add_table_label">Add Tables:</h4>
                </div>

                <div class="modal-body" style="max-height: 60vh;overflow-y: auto;">
                    <form method="post" @submit.prevent="addNewTable()">
                    <div class="row form-group" style="margin:10px">
                        <div class="form-group">
                            <label>Select Branch</label>
                            <select class="form-control" v-model="branchId" style="background: #FFFFFF" v-on:change="fetchTables()">
                                <option v-for="branch in allBranches" v-bind:key="branch.id+'_branch'" v-bind:value="branch.id">{{branch.areasByAreaId.name}}</option>
                            </select>
                        </div>
                        <div v-if="branchId!==''">
                            <div class="form-group">
                                <label for="name">Name</label>
                                <input v-model="slotName" type="text" required class="form-control" id="name" placeholder="Name...">
                            </div>
                            <select v-model="slotType" class="form-control" style="background: #FFFFFF" required>
                                <option value="2">Dine In</option>
                                <option value="1">Take Away</option>
                            </select>                                
                        </div>
                    </div>

                    <button type="submit" class="btn btn-primary pull-right" style="margin:10px;">Add Table</button>
                        
                    </form>

                    <br>
                    <!-- <hr> -->
                    <table class="table table-bordered table-hover table-stripped" v-if="branchId!==''"> 
                        <thead>
                            <tr>
                                <th class="text-center">ID</th>
                                <th class="text-center">Slot Name</th>
                                <th class="text-center">Slot Type</th>
                                <th class="text-center"><i class="fa fa-bolt"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(table, tableIndex) in tables">
                                <tr :key="tableIndex + '_' + table.id" v-if="!table.deleted">
                                    <td class="text-center">{{table.id}}</td>
                                    <td class="text-center">{{table.name}}</td>
                                    <td class="text-center">{{table.tableType===1 ? "Take Away" : "Dine In"}}</td>
                                    <th class="text-center"><button @click="deleteTable(table.id)" class="btn btn-danger btn-md"><i class="fa fa-times"></i></button></th>
                                </tr>
                            </template>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>

<!-- Add Waiters modal -->

    <div class="modal fade" id="add_waiter" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
        <div class="modal-dialog" role="document" style="overflow-y: initial !important">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="add_waiter_label">Add Waiters</h4>
                </div>

                <div class="modal-body" style="max-height: 60vh;overflow-y: auto;">
                    <form method="post" @submit.prevent="addNewWaiter()">
                    <div class="row form-group" style="margin:7px">
                            <div class="form-group">
                                <label>Select Branch</label>
                                <select class="form-control" v-model="branchId" style="background: #FFFFFF" v-on:change="fetchWaiters()">
                                    <option v-for="branch in allBranches" v-bind:key="branch.id+'_branch'" v-bind:value="branch.id">{{branch.areasByAreaId.name}}</option>
                                </select>
                            </div>
                            <div class="form-group" v-if="branchId!==''">
                                <label for="name">Waiter Name</label>
                                <input v-model="waiterName" type="text" required class="form-control" id="waiter_name" placeholder="waiter">
                            </div>
                    </div>
                    <button type="submit" class="btn btn-primary pull-right" style="margin:10px;">Add Waiter</button>
                    </form>
                    <table class="table table-bordered table-hover table-stripped" v-if="branchId!==''">
                        <thead>
                            <tr>
                                <th class="text-center">ID</th>
                                <th class="text-center">Waiter Name</th>
                                <th class="text-center"><i class="fa fa-bolt"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="(waiter, waiterIndex) in waiters">
                                <tr :key="waiterIndex + '_' + waiter.id" v-if="!waiter.deleted">
                                    <td class="text-center">{{waiter.id}}</td>
                                    <td class="text-center">{{waiter.name}}</td>
                                    <th class="text-center"><button @click="deleteWaiter(waiter.id)" class="btn btn-danger btn-md"><i class="fa fa-times"></i></button></th>
                                </tr>
                            </template>
                        </tbody>
                    </table>

                </div>
            </div>
        </div>
    </div>

</div>

</template>

<script>
    export default {
        name: "addTables",
        data() {
          return {
              allBranches:[],
              branchId:"",
              slotName:"",
              slotType:"2",
              tables:"",
              table:{
                  name: "",
                  tableType: "",
                  branch:{
                      id:""
                  }
              },
              waiterName: "",
              waiters:"",
              waiterObj: {
                  name:"",
                  branch:{
                      id:""
                  }
              }

          }
        },
        updated: function(){
            $('#add_table').on('hidden.bs.modal', ()=>{
                this.branchId='';
            });
            $('#add_waiter').on('hidden.bs.modal', ()=>{
                this.branchId='';
            })
        },
        methods: {
             loadTableModal(allBranches) {
                 this.allBranches= allBranches;
                $('#add_table').modal("show")
            },
            loadWaiterModal: function(allBranches){
                this.allBranches= allBranches
                $("#add_waiter").modal("show")
            },
            addNewTable: function(){
                    Swal.fire({
                        title: 'Please Wait! We are processing the data.',
                        type: 'info',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        onBeforeOpen: () => {
                            Swal.showLoading();
                        },
                    });
                this.table.name=this.slotName;
                this.table.tableType= this.slotType;
                this.table.branch.id= this.branchId;
                this.$http.post(this.$store.state.mainAppURL + "tables/", this.table).then(async resp=>{
                await this.fetchTables();
                Swal.close();
                })
            },
            addNewWaiter: function(){
                    Swal.fire({
                        title: 'Please Wait! We are processing the data.',
                        type: 'info',
                        allowOutsideClick: false,
                        allowEscapeKey: false,
                        onBeforeOpen: () => {
                            Swal.showLoading();
                        },
                    });
                    this.waiterObj.name= this.waiterName;
                    this.waiterObj.branch.id= this.branchId;
                    this.$http.post(this.$store.state.mainAppURL + "waiters/", this.waiterObj).then(async resp=>{
                        await this.fetchWaiters();
                        Swal.close();
                    })                
            },
            deleteTable: function(tableId){
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                this.$http.delete(this.$store.state.mainAppURL + "tables/" + tableId).then(resp=>{
                    Swal.close();
                    this.fetchTables();
                    Swal("Deleted","Table Has Been Deleted", "success");
                });

            },
            deleteWaiter: function(waiterId){
                Swal.fire({
                    title: 'Please Wait! We are processing the data.',
                    type: 'info',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    onBeforeOpen: () => {
                        Swal.showLoading();
                    },
                });
                this.$http.delete(this.$store.state.mainAppURL + "waiters/" + waiterId).then(resp=>{
                    Swal.close();
                    this.fetchWaiters();
                    Swal("Deleted", "Waiter Has Been Deleted", "success");
                })
            },
            fetchTables: async function(){
                let params= new URLSearchParams();
                params.append("branch_id", this.branchId);
                let tables= await this.$http.post(this.$store.state.mainAppURL + "tables/get_all_tables", params)
                this.tables= tables.data;
                // Swal.close();
                this.resetTableObj();
            },
            fetchWaiters: async function(){
                let params= new URLSearchParams();
                params.append("branch_id", this.branchId);
                let resp= await this.$http.post(this.$store.state.mainAppURL + "waiters/get_all_waiters", params);
                this.waiters= resp.data;
                this.resetWaiterObj();
            },
            resetTableObj:function(){
                this.slotName="";
                this.slotType="2";
                this.table={
                    name:"",
                    tableType:"",
                    branch:{
                        id:""
                    }
                }
            },
            resetWaiterObj: function(){
                this.waiterName="";
                this.waiterObj={
                    name:"",
                    branch:{
                        id:""
                    }
                }
            }


        },
    }
</script>

<style scoped>

</style>
